import React, { useContext } from 'react'
import { MicroFrontend } from '@praxis/component-microfrontend'
import { useAuth } from '@praxis/component-auth'
import { useEnv } from '@praxis/component-runtime-env'
import { envConfigs, ReactAppEnv } from 'apiConfig'
import { UserContext } from 'App/UserContext'
import { PageLayout } from '@plm-core/utils'

export const NotificationPage: React.FC = () => {
  const auth = useAuth()
  const { sparkUser } = useContext(UserContext)
  const { environment }: { environment: ReactAppEnv } = useEnv()
  const { notifications } = envConfigs[environment]

  return (
    <PageLayout>
      <MicroFrontend
        src={notifications.mfeUrl}
        module="./NotificationCenterWidget"
        userId={sparkUser?.userId ?? ''}
        apiConfig={notifications.apiConfig}
        analyticsConfig={notifications.analyticsConfig}
        firebaseConfig={notifications.firebaseConfig}
        auth={auth}
      />
    </PageLayout>
  )
}
